import { Component, OnInit,  ViewChild, EventEmitter, ElementRef } from '@angular/core';
import { RootScopeService } from '../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../core/rootscope-declare';
import { ActivatedRoute, Router, NavigationEnd, Event as NavigationEvent } from '@angular/router';
import { FacilityService } from 'src/app/core/services/facility.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { Subscription } from 'rxjs';
import { HaloLoaderService } from '../../../core/halo-loader/halo-loader.service';
import { MemberFirebaseTokenService, IToken } from '../../services/member-firebase-token.service';
import {tab, TRAININGDATA } from '../training-data';
import { environment } from '../../../../environments/environment';
import { SafeUrl } from '@angular/platform-browser';
import { CommonUtil } from '../../../core/Utils/common-util';
import { BreadcrumbService } from '../../services/breadcrumb.service';

@Component({
  selector: 'app-promote',
  templateUrl: './promote.component.html',
  styleUrls: ['./promote.component.scss']
})
export class PromoteComponent implements OnInit {

 // subscriptions
 private _facilityOnChange: Subscription;
 private _tabOnChange: Subscription;
 rootScopeData: RootScopeDeclare;
 currentFacility: FacilityObject;
 memberToken: string;
 membrBasePath: string;
 memberSubPath: SafeUrl|null = '';
 currentPath:string = 'dashboard';
 currentTabDetails:tab[] =[{page:'', key:'', url:''}];
 memberTabs:string[] = ['massEmails', 'emailWizard', 'memberPathways', 'attractScreens', 'announcements'];
 breadCrumbData = ['HOME','DASHBOARD','MEMBERS','PROMOTE','MASS.EMAILS'];
 showIframeLoader = true;
 displayAttractScreen = false;
 displayAnnouncement = false;

 constructor(private rootScopeService: RootScopeService,
  private _breadcrumbService: BreadcrumbService,
   private _facilityService: FacilityService,
   private _router: Router,
   private _getMemberToken: MemberFirebaseTokenService,
   private loader: HaloLoaderService,
   private _commonUtil: CommonUtil) { }

   ngOnInit(): void {
    this.getRootScopeData();
    this.membrBasePath = environment.membrHostPath; 
 
    // subscript facility change / when facility change
    this.currentFacility = this._facilityService.selectedFacility();
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe(res => {
      this.currentFacility = res;
      this.fetchMemberData();
      this.displayAttractScreen = this.checkHasAttractScreen();      
      this.displayAnnouncement = this.checkHasAnnouncement(); 
    });
 
    let path = this._router.url.split("/");
    this.currentPath = path[path.length-1];    
    this.setTabDetails(this.currentPath);
 
    this._tabOnChange = this._router.events.subscribe(
      (event: NavigationEvent): void => {
        if (event instanceof NavigationEnd) {
          let path = this._router.url.split("/");
          this.currentPath = path[path.length-1];         
          this.setTabDetails(this.currentPath);
          this.fetchMemberData();  
        }
      }
    );
 
    this.fetchMemberData();
}

 getRootScopeData(): void {
   this.rootScopeService.getRootScope().subscribe(rootScopeData => {
     this.rootScopeData = rootScopeData;
   });
 }

 goToTab(name:string){
  this.currentPath = name;
  this.setTabDetails(this.currentPath);
  this.fetchMemberData();  
  if(name === 'massEmails'){
    this.breadCrumbData[4] = 'MASS.EMAILS';
  }else if(name === 'emailWizard'){
    this.breadCrumbData[4] = 'EMAIL.WIZARD';
  }else if(name === 'memberPathways'){
    this.breadCrumbData[4] = 'MEMBER.PATHWAYS';
  }
  this._breadcrumbService.set(this.breadCrumbData);
 }

 checkHasAnnouncement(){
  let status = false;
  this.currentFacility.consoleEquipments.forEach(equipment => {
    let consoleRight = this.rootScopeData.consoleRights.get(equipment.consoleType);
    if(consoleRight.hasAnnouncements ==="true"){
      status = true;
    }
  });
   return status;
}
checkHasAttractScreen(){
  let status = false;
  this.currentFacility.consoleEquipments.forEach(equipment => {
    let consoleRight = this.rootScopeData.consoleRights.get(equipment.consoleType);
    if(consoleRight.hasAttractScreen ==="true"){
      status = true;
    }
  });
   return status;
}

 setTabDetails(name: string): void {
   if(this.memberTabs.indexOf(name)> -1){
     this.rootScopeData.pageName = 'Member - MANAGE';
   }else{
     this.rootScopeData.pageName = 'Member - ' + name ;
   }
   this.currentTabDetails = TRAININGDATA.filter(u => 
     u.page == name);
 }

 ngOnDestroy() {
   // destroy subscriber
   if (this._facilityOnChange) {
     this._facilityOnChange.unsubscribe();
   }
   this._tabOnChange.unsubscribe();
 }

 fetchMemberData(){
   if ((this.currentFacility.summary && this.currentFacility.summary.facilityRights.trainingMenu != 'true') ||
   (this.currentFacility.summary && this.currentFacility.summary.facilityRights.trainingClasses == 'false' && this.memberTabs.indexOf(this.currentPath)> -1) ||
   (this.currentFacility.summary && this.currentFacility.summary.facilityRights.trainingPrograms == 'false' && (this.currentPath.indexOf('dashboard')>-1 || this.currentPath.indexOf('training')>-1))) {
     this._commonUtil.redirectToAvailablePage();
   }
   this.getToken();
 }

 getToken(){    
   this.loader.startProcess();
     this._getMemberToken
       .get()
       .subscribe(
         (data: IToken) => {
           this.loader.endProcess();
           this.memberToken=data.jwtToken;
           if(this.memberSubPath && this.memberSubPath.toString().indexOf('<facId>')>-1)
             this.memberSubPath=this.memberSubPath.toString().replace('<facId>',this.currentFacility.facilityId);
           else
             this.memberSubPath = this.membrBasePath + this.memberToken + this.currentTabDetails[0].url+"&facilityId="+this.currentFacility.facilityId+"&locale="+this.rootScopeData.currentUser.preferredLanguage;
           
         },
         error => {
           console.error('API failed.');
           this.loader.endProcess();
         }
       );
 }

 showLoadSpinner(){
   this.showIframeLoader =true;
 }

 hideLoadSpinner(){
   this.showIframeLoader =false;
 }

 tryToMoveAwayFromCurrentPage(path: string) {
  this.rootScopeData.pathToNavigate = path;
  if (this.rootScopeData.pathToNavigate.indexOf('app.html') >= 0) {
    window.location.href = this.rootScopeData.pathToNavigate;
  } else if (this.rootScopeData.pathToNavigate !== this._router.url) {
    window.location.href ='halo.html#'+ this.rootScopeData.pathToNavigate;
  }else{
    window.location.href=path;
  }
}
}
